export default __webpack_public_path__ + "static/media/gm.b64cfca2.png";